import { render, staticRenderFns } from "./AsAcceptButton.vue?vue&type=template&id=5af9d943&scoped=true"
import script from "./AsAcceptButton.vue?vue&type=script&lang=js"
export * from "./AsAcceptButton.vue?vue&type=script&lang=js"
import style0 from "./AsAcceptButton.vue?vue&type=style&index=0&id=5af9d943&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af9d943",
  null
  
)

export default component.exports